export default "__VITE_ASSET__DvC8HZoz__"